// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"754fec2f","372":"bf3395aa","407":"fecea269","464":"272bca5f"}[chunkId] + ".chunk.css";
};